export default {
  cheques_pending: false,
  cheques: []
}
